import { InputGroupChangeTracker } from '../change_trackers';
import { InputChangeType } from '../types';

export type ContractComparisonFilter = 'all' | 'onlyWithChanges' | 'withoutChanges' | InputChangeType;

export const getVisibleComparisonInputIds = (
    selectedFilter: ContractComparisonFilter,
    inputIds: string[],
    inputGroupChangeTracker: InputGroupChangeTracker
): string[] => {
    switch (selectedFilter) {
        case 'all':
            return inputIds;
        case 'onlyWithChanges':
            return inputGroupChangeTracker.changedInputIds;
        case 'withoutChanges':
            return inputIds.filter(inputId => !inputGroupChangeTracker.changedInputIds.includes(inputId));
        case 'added':
            return inputGroupChangeTracker.changeCounts.added.inputIds;
        case 'removed':
            return inputGroupChangeTracker.changeCounts.removed.inputIds;
        case 'modified':
            return inputGroupChangeTracker.changeCounts.modified.inputIds;
        case 'unsaved':
            return inputGroupChangeTracker.changeCounts.unsaved.inputIds;
        default:
            return inputIds;
    }
};
